module.exports = __webpack_public_path__ + "img/game5.87bb9337.png";